import React, { useState } from 'react';
import { Col, Form, Row ,Card , Table}  from 'react-bootstrap';
import { toast } from 'react-toastify';
import FalconComponentCard from 'components/common/FalconComponentCard';
import { Button } from 'react-bootstrap';
import { ApiCall } from '../../../includes/Webservice';
import { BaseUrl, getUserStorageData, showDBdatetime, convertDBdate, timeAgoSinceDate ,convertReportText } from '../../../includes/Helper';
import { Link, useNavigate, useParams } from 'react-router-dom'
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import Background from 'components/common/Background';
import corner7 from 'assets/img/illustrations/corner-7.png';
import SubtleBadge from 'components/common/SubtleBadge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import createMarkup from 'helpers/createMarkup'; 

//var content = `The provided images appear to be axial and coronal slices from a non-contrast computed tomography (CT) scan of the brain. Findings:1. The axial and coronal planes reveal multiple hyperdense areas within the brain parenchyma indicative of hemorrhagic foci. These are marked with green arrows in one of the axial images and with yellow arrows in the coronal and another axial view.2. There is evidence of intraventricular hemorrhage as seen by hyperdense signal within the ventricular system, specifically within the third and fourth ventricles as marked by green arrows.3. Mass effect causing a shift of the midline structures is suggested by the asymmetric appearance of the ventricles and subarachnoid spaces.4. The coronal plane image with yellow arrows also demonstrates subarachnoid hemorrhage, where there is hyperdensity outlining the sulci and cisterns.5. There is no clear evidence of significant cerebral edema, which would be indicated by loss of the differentiation between grey and white matter.6. The last image with red arrows is pointing towards the basilar cisterns, which appear hyperdense and likely indicate subarachnoid hemorrhage in this region. Incidental Note: - Due to the absence of clinical context and previous imaging, it's difficult to make an incidental note beyond the findings related to the acute findings of hemorrhage. Impression: - Multifocal intracerebral hemorrhage with intraventricular and subarachnoid extension leading to mass effect and midline shift. Differential Diagnosis: - Hypertensive hemorrhage can often present with deep structure involvement and intraventricular extension. - Ruptured aneurysm given the subarachnoid hemorrhage and possible mixed intracerebral hemorrhages. - Coagulopathies or anticoagulant medication use leading to spontaneous hemorrhage. - Underlying vascular malformation such as arteriovenous malformation or cavernous hemangioma. Recommendations: - Clinical correlation is mandatory for further evaluation including history regarding onset of symptoms, potential risk factors like hypertension, anticoagulant therapy, family history of cerebrovascular diseases, and any recent trauma. - Urgent neurosurgical evaluation for potential management of intracranial pressure and consideration of surgical evacuation of hematoma if clinically indicated. - Additional imaging such as a CT angiogram or digital subtraction angiography (DSA) for the evaluation of an underlying vascular anomaly. - Close monitoring of neurological status and intracranial pressure; administration of interventions to control hypertension and any consideration of reversal of coagulopathy if present. Concluding Remarks: The current imaging depicts a critical situation requiring immediate attention to prevent further neurological deterioration. Management should be multidisciplinary involving radiology, neurosurgery, and possibly interventional neuroradiology. Identifying`; 

//content = convertReportText(content);
//var newstr = content.replaceAll("\n", "<br/>"); 
//console.log(content)
 
const Other = () => { 

    const navigate = useNavigate();
    const baseurl = BaseUrl();
    const controller = new AbortController();
    const [list, setList] = React.useState({});
    const [isPageloading, setPageLoad] = React.useState(false);
    const [status1, setStatus1] = React.useState(false);
    const [status2, setStatus2] = React.useState(false);
    const [status3, setStatus3] = React.useState(false);
    const [status4, setStatus4] = React.useState(false);
    const [date1, setDate1] = React.useState('');
    const [date2, setDate2] = React.useState('');
    const [date3, setDate3] = React.useState('');
    const [date4, setDate4] = React.useState('');
    React.useEffect(() => {
        onLoad();

        return () => {
            // Anything in here is fired on component unmount.
            //    console.log('Unmount Component')
            controller.abort();
        }

    }, [])

    const onLoad  = async () => {
 
        const data ={ } 
        const result = await ApiCall(baseurl + "/apiurl/status", "post",  1,0, 0, data, '', controller);

        if (result) {
            // setPageLoad(false)
            if (result.status == true) {             
                  setList(result.data)
                  if(result.api_status.api_convert_image_status !=null)
                  {
                   if(result.api_status.api_convert_image_status.result)
                     setStatus1(true)
                      setDate1(showDBdatetime(result.api_status.api_convert_image_status.createdate));
                }
                  if(result.api_status.api_check_image_status !=null)
                  {
                if(result.api_status.api_check_image_status.result)
                     setStatus2(true)
                     setDate2(showDBdatetime(result.api_status.api_check_image_status.createdate))
                }
                 if(result.api_status.api_process_image_status !=null)
                 {
                 if(result.api_status.api_process_image_status.result)
                     setStatus3(true)
                     setDate3(showDBdatetime(result.api_status.api_process_image_status.createdate))
                }
                if(result.api_status.api_convert_zip_status !=null)
                 {
                 if(result.api_status.api_convert_zip_status.result)
                  setStatus4(true)
                     setDate4(showDBdatetime(result.api_status.api_convert_zip_status.createdate))
                }
            } else {
                navigate('/');
                toast.error(result.message);
            }
        } else {
            // setPageLoad(false)
            toast.error(`Some error occured, try again later` );
            navigate('/');
        } 
    }

    return (
        <Row className="g-3">
              <Col lg={12} xxl={6}>
                <Card className="mb-3 border border-warning h-100">
                <Background
                    image={corner7}
                    className="bg-card"
                    style={{
                    borderTopRightRadius: '0.375rem',
                    borderBottomRightRadius: '0.375rem'
                    }}
                />
                <Card.Body className="pb-0 position-relative">
                   
                    <h3 className="mt-3 text-warning">API Status</h3>
                    <p className="mb-0">
                    We are using below API, to generate report.
                    </p>
              
              {/*}
                    <Form.Control
                        as="textarea"
                        rows={15} 
                        readOnly
                        placeholder="API Response"
                        value={content}  
                    />

                <p className="mb-1 fw-semibold" dangerouslySetInnerHTML={createMarkup(newstr)} />{*/}
                     
                <Table className="fs-10 mt-3">
                    <thead>
                    <tr>
                        <th>API For</th>
                        <th>URL</th>
                        <th>Status</th>
                        <th>Last Check</th>
                    </tr>    
                    </thead> 
                    <tbody> 
                    <tr key={1}>
                        <td className="bg-100" style={{ width: '30%' }}>
                        Convert Diacom to PNG
                        </td>
                        <td> <a target='_blank' href={list.api_convert_image}> {list.api_convert_image}</a> </td>
                        <td>  
                        {status1  ?
                        <FontAwesomeIcon className='text-success me-2' size='lg' icon={'circle'} /> 
                        : 
                        <FontAwesomeIcon className='text-danger me-2' size='lg' icon={'circle'} /> 
                        }
                                  </td>
                        <td>{date1}</td>
                      </tr>
                      <tr key={2}>
                      <td>
                            Check Image
                            </td>
                            <td>
                            <a target='_blank' href={list.api_check_image}>  {list.api_check_image} </a> 
                            </td>
                        <td>    {status2  ?
                        <FontAwesomeIcon className='text-success me-2' size='lg' icon={'circle'} /> 
                        : 
                        <FontAwesomeIcon className='text-danger me-2' size='lg' icon={'circle'} /> 
                        }  </td>
                        <td> {date2}  </td>
                      </tr>
                      <tr key={3}>
                      <td>
                            Process Image
                            </td>
                            <td>
                            <a target='_blank' href={list.api_process_image}>  {list.api_process_image} </a> 
                            </td>
                        <td>   {status3  ?
                        <FontAwesomeIcon className='text-success me-2' size='lg' icon={'circle'} /> 
                        : 
                        <FontAwesomeIcon className='text-danger me-2' size='lg' icon={'circle'} /> 
                        }    </td>
                        <td> {date3}  </td>
                      </tr>
                      <tr key={4}>
                      <td>
                            Zip API
                            </td>
                            <td>
                            <a target='_blank' href={list.api_convert_zip}>  {list.api_convert_zip} </a> 
                            </td>
                        <td>   {status4  ?
                        <FontAwesomeIcon className='text-success me-2' size='lg' icon={'circle'} /> 
                        : 
                        <FontAwesomeIcon className='text-danger me-2' size='lg' icon={'circle'} /> 
                        }    </td>
                        <td> {date4}  </td>
                      </tr>
                    </tbody>
               </Table>



               </Card.Body>
                
                </Card>
            </Col>
    </Row>
    );
};
 

export default Other;
